<div>
    <div class="wizard-header row">
        <div class="col-12 page-title">
            {{'specialOffers.title' | translate}}
        </div>
    </div>

    <div class="wizard-container">
        <button
            class="btn link-btn btn-back-txt"
            (click)="redirectToPrevStep()">
            <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
            <span>
                {{("specialOffers.wizard.previousStep" | translate)}}
            </span>
        </button>

        <div class="wizard-main-content">
            <form #form="ngForm">
                <ng-container class="wizard-item">
                    <div class="row">
                        <div class="col-12 wizard-question">
                            {{ "specialOffers.wizard.clientSegmentation.title" | translate }}
                            <div class="skip-step">
                                {{ "specialOffers.wizard.clientSegmentation.skip1" | translate }}
                                <span (click)="nextStepHandler()">
                                    {{ "specialOffers.wizard.clientSegmentation.skip2" | translate }}
                                </span>
                                {{ "specialOffers.wizard.clientSegmentation.skip3" | translate }}
                            </div>
                        </div>
                        <div class="row justify-content-center mb-3">
                            <div class="segment-container col-lg-10 col-xxl-8 col-xxxl-6">
                                <div class="row justify-content-center mb-3">
                                    <div class="col-md-12">
                                        <kendo-switch
                                            HJSuppress
                                            HJSuppress
                                            [(ngModel)]="segmentationToggle.segment"
                                            class="me-3"  
                                            name="segmentationToggle"
                                            (valueChange)="changeSegmentFilterHandler($event)">
                                        </kendo-switch>
                                        <span>{{ "specialOffers.wizard.clientSegmentation.segment" | translate }}</span>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-md-12">
                                        <label class="label-input">
                                            {{ "specialOffers.wizard.clientSegmentation.type" | translate }}
                                        </label>
                                        <div class="input-dropdown-container">
                                            <kendo-combobox
                                                HJSuppress
                                                class="custom-kendo-control-xl"
                                                [size]="sizeLarge"
                                                [fillMode]="fillModeOutline"
                                                [rounded]="roundedLarge"
                                                name="segmentTypeId"
                                                [placeholder]="'specialOffers.wizard.clientSegmentation.placeholder.selectSegmentType' | translate"
                                                [clearButton]="false"
                                                [valuePrimitive]="true"
                                                [disabled]="!segmentationToggle.segment"
                                                [data]="segmentTypes"
                                                [valueField]="'id'"
                                                [textField]="'value'"
                                                [(ngModel)]="specialOffer.dictionarySegmentItemTypeExternalEntityId"
                                                (ngModelChange)="segmentTypeSelectedHandler($event)"
                                                [popupSettings]="{popupClass : 'data-hj-suppress'}"
                                                #segmentType
                                                (click)="!segmentType.isOpen && !segmentType.disabled ?
                                                segmentType.toggle() : null"
                                                [required]="segmentationToggle.segment">
                                            </kendo-combobox>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-md-12">
                                        <label class="label-input">
                                            {{ "specialOffers.wizard.clientSegmentation.segmentValue" | translate }}
                                        </label>
                                        <div class="input-dropdown-container">
                                            <kendo-multiselect
                                                HJSuppress
                                                class="custom-kendo-control-xl"
                                                [size]="sizeLarge"
                                                [fillMode]="fillModeOutline"
                                                [rounded]="roundedLarge"
                                                name="segmentItems"
                                                [placeholder]="'specialOffers.wizard.clientSegmentation.placeholder.selectSegmentValue' | translate"
                                                (ngModelChange)="campaignTypeSelectedHandler($event)"
                                                [clearButton]="false"
                                                [valuePrimitive]="false"
                                                [disabled]="!specialOffer.dictionarySegmentItemTypeExternalEntityId"
                                                [data]="segmentItems"
                                                [valueField]="'id'"
                                                [textField]="'value'"
                                                [(ngModel)]="selectedSegmentItems"
                                                [popupSettings]="{popupClass : 'data-hj-suppress'}"
                                                #segmentItem
                                                (click)="!segmentItem.isOpen && !segmentItem.disabled ?
                                                segmentItem.toggle() : null"
                                                [required]="segmentationToggle.segment">
                                            </kendo-multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center mb-3">
                            <div class="segment-container col-lg-10 col-xxl-8 col-xxxl-6">
                                <div class="row justify-content-center mb-3">
                                    <div class="col-md-12">
                                        <kendo-switch
                                            HJSuppress
                                            [(ngModel)]="segmentationToggle.maximumPaymentDelay"
                                            class="me-3"
                                            (valueChange)="changeMaximumPaymentDelayHandler($event)"
                                            name="maximumPaymentDelayToggle">
                                        </kendo-switch>
                                        <span>
                                            {{ "specialOffers.wizard.clientSegmentation.overdueDays" | translate}}
                                        </span>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-md-12">
                                        <label class="label-input">
                                            {{ "specialOffers.wizard.clientSegmentation.paymentDelay" | translate }}
                                        </label>
                                        <div class="input-dropdown-container">
                                            <kendo-numerictextbox
                                                HJSuppress
                                                class="l-numeric-textbox-container"
                                                format="n0"
                                                [spinners]="false"
                                                [min]="0"
                                                [(ngModel)]="specialOffer.maximumPaymentDelay"
                                                name="maximumPaymentDelay"
                                                placeholder="{{'specialOffers.wizard.clientSegmentation.placeholder.typeOverdueDays' | translate}}"
                                                [disabled]="!segmentationToggle.maximumPaymentDelay"
                                                [required]="segmentationToggle.maximumPaymentDelay">
                                            </kendo-numerictextbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center mb-3">
                            <div class="segment-container col-lg-10 col-xxl-8 col-xxxl-6">
                                <div class="row justify-content-center mb-3">
                                    <div class="col-md-12">
                                        <kendo-switch
                                            HJSuppress
                                            [(ngModel)]="segmentationToggle.periodUntilTermination"
                                            class="me-3"
                                            (valueChange)="changePeriodUntilTerminationHandler($event)"
                                            name="periodUntilTerminationoggle">
                                        </kendo-switch>
                                        <span>
                                            {{ "specialOffers.wizard.clientSegmentation.periodUntilTermination" | translate}}
                                        </span>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-md-12">
                                        <label class="label-input">
                                            {{ "specialOffers.wizard.clientSegmentation.period" | translate }}
                                        </label>
                                        <div class="input-dropdown-container">
                                            <kendo-numerictextbox
                                                HJSuppress
                                                class="l-numeric-textbox-container"
                                                format="n0"
                                                [spinners]="false"
                                                [min]="0"
                                                [(ngModel)]="specialOffer.periodUntilTermination"
                                                name="periodUntilTermination"
                                                placeholder="{{'specialOffers.wizard.clientSegmentation.placeholder.typePeriodUntilTermination' | translate}}"
                                                [disabled]="!segmentationToggle.periodUntilTermination"
                                                [required]="segmentationToggle.periodUntilTermination">
                                            </kendo-numerictextbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 action">
                            <div class="d-flex justify-content-center mt-5">
                                <button
                                    class="btn primary-btn"
                                    (click)="nextStepHandler()"
                                    [disabled]="form.invalid">
                                    {{ "specialOffers.wizard.nextBtn" | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </form>
        </div>
    </div>
</div>